import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { AuthenticationService } from '../../../../access/shared/authentication/authentication.service'
import { User } from '../shared/user'
import { UserService } from '../shared/user.service'

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnDestroy {

  dataSource: MatTableDataSource<User> = new MatTableDataSource<User>()
  users: MatTableDataSource<User> = new MatTableDataSource<User>()
  displayedColumns = ['username', 'lastname', 'firstname', 'email', 'phone', 'lastLogin', 'actif', 'actions']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator

  private sub: Subscription

  loading: boolean = false
  filter = ""
  inactif = false
  isExportUser: boolean = false
  isExportAccess: boolean = false
  isAdminSite: boolean = false

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.loading = true

    this.isAdminSite = this.authenticationService.currentUser$.getValue().roles.includes('ROLE_ADMIN_SITE') || this.authenticationService.currentUser$.getValue().roles.includes('ROLE_ADMIN_GLOBAL')

    this.sub = this.userService.getClientUsers().subscribe(
      users => {
        this.dataSource.data = users
        this.users.data = this.dataSource.data
        this.paginator._intl.itemsPerPageLabel = 'Utilisateurs par page '
        this.users.paginator = this.paginator
        this.loading = false
        this.applyFilter(this.filter)
        return this.users.data
      })
  }

  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe()
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue?.toLowerCase()
    this.filter = filterValue
    if (!this.loading) {
      this.users.data = this.dataSource.data.filter(data => {
        return (this.inactif || data.enabled) && (data.firstname?.toLowerCase().includes(filterValue) || data.lastname?.toLowerCase().includes(filterValue) || data.email?.toLowerCase().includes(filterValue) || data.username?.toLowerCase().includes(filterValue))
      })
    }
  }

  actif(value) {
    this.inactif = value.checked
    if (!this.loading) {
      this.users.data = this.dataSource.data.filter(data => {
        return (this.inactif || data.enabled) && (data.firstname?.toLowerCase().includes(this.filter) || data.lastname?.toLowerCase().includes(this.filter) || data.email?.toLowerCase().includes(this.filter) || data.username?.toLowerCase().includes(this.filter))
      })
    }
  }

  editUser(user: User) {
    this.router.navigate(['../', user.id], {
      relativeTo: this.route
    })
  }

  export() {
    this.isExportUser = true
    this.userService.exportUsers().subscribe(data => {
      this.isExportUser = false
    }, error => {
      this.isExportUser = false
    })
  }

  exportClientAccess() {
    this.isExportAccess = true
    this.userService.exportLastAccess().subscribe(data => {
      this.isExportAccess = false
    }, error => {
      this.isExportAccess = false
    })
  }
}
